import { render, staticRenderFns } from "./JewelHistoryListItem.vue?vue&type=template&id=2377ad06&scoped=true&"
import script from "./JewelHistoryListItem.vue?vue&type=script&lang=js&"
export * from "./JewelHistoryListItem.vue?vue&type=script&lang=js&"
import style0 from "./JewelHistoryListItem.vue?vue&type=style&index=0&id=2377ad06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2377ad06",
  null
  
)

export default component.exports